import React, { useEffect, useState } from 'react';

// import utility file
// import node module libraries
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';

import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import BulletinnoteProfileLayout from './BulletinnoteProfileLayout';
import { useParams } from 'react-router-dom';
import SalledeclasseService from '../../services/SalledeclasseService';
import AnneescolaireService from '../../services/AnneescolaireService';
import ExamenService from '../../services/ExamenService';
import MatiereService from '../../services/MatiereService';
import CompetenceService from '../../services/CompetenceService';
import BulletinnoteService from '../../services/BulletinnoteService';

const ViewBulletinnote = () => {
	const { salledeclasseId, eleveId } = useParams();
	const [salledeclasse, setSalledeclasse] = useState(null);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);
	const [examenOptions, setExamenOptions] = useState([]);
	const [matiereOptions, setMatiereOptions] = useState([]);
	const [competenceOptions, setCompetenceOptions] = useState([]);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	// Créez un état pour stocker les notes par défaut
	const [selectedBulletinNotes, setSelectedBulletinNotes] = useState({});
	const [bulletinId, setBulletinId] = useState(null);

	useEffect(() => {
		Promise.all([SalledeclasseService.getSalledeclasse(salledeclasseId)]).then(
			([salledeclasseData]) => {
				setSalledeclasse(salledeclasseData.data);
			}
		);
	}, [salledeclasseId]);

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		fetchCurrentSchoolYear();
	}, []);

	useEffect(() => {
		const fetchExamenOptions = async () => {
			try {
				const Examens = await ExamenService.getExamenOptions();
				setExamenOptions(Examens);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchExamenOptions();
	}, []);

	useEffect(() => {
		const fetchMatiereOptions = async () => {
			try {
				const Matieres = await MatiereService.getMatiereOptions(
					salledeclasseId
				);
				setMatiereOptions(Matieres);
			} catch (error) {
				console.error('Error fetching Matiere options', error);
			}
		};

		fetchMatiereOptions();
	}, [salledeclasseId]);

	useEffect(() => {
		const fetchCompetenceOptions = async () => {
			try {
				const Competences = await CompetenceService.getCompetenceOptions(
					salledeclasseId
				);
				setCompetenceOptions(Competences);
			} catch (error) {
				console.error('Error fetching Competence options', error);
			}
		};

		fetchCompetenceOptions();
	}, [salledeclasseId]);

	function getTrimestre(examValue) {
		if (examValue >= 1 && examValue <= 3) {
			return 1;
		} else if (examValue >= 4 && examValue <= 6) {
			return 2;
		} else if (examValue >= 7 && examValue <= 9) {
			return 3;
		} else {
			return null; // Ou une autre valeur par défaut si l'examen n'est pas dans les plages spécifiées
		}
	}

	// Gérez le changement de sélection d'examen
	const handleExamenChange = async (selectedExamen) => {
		// Déclenchez une requête pour obtenir les bulletins de l'élève pour l'année scolaire actuelle
		const selectedBulletin = await BulletinnoteService.getBulletinEvaluation(
			salledeclasseId,
			eleveId,
			selectedExamen,
			currentSchoolYear.id
		);

		if (selectedBulletin) {
			setBulletinId(selectedBulletin.id);
			let filterNotes = selectedBulletin.notes_evaluations;

			// Tri par ordre croissant d'identifiant si filterNotes est défini et est un tableau
			if (filterNotes && Array.isArray(filterNotes)) {
				filterNotes = filterNotes.sort((a, b) => a.id - b.id);
			}

			// Si un bulletin correspondant est trouvé, utilisez ses notes comme valeurs par défaut
			if (filterNotes) {
				setSelectedBulletinNotes(filterNotes);
			} else {
				// Si aucun bulletin correspondant n'est trouvé, réinitialisez les notes
				setSelectedBulletinNotes({});
			}
		} else {
			// Si aucun bulletin correspondant n'est trouvé, réinitialisez les notes
			setSelectedBulletinNotes({});
		}
	};

	const Examen_CHOICES = examenOptions;

	let renderedFields;
	if (
		salledeclasse &&
		(['class_four', 'class_five', 'class_six'].includes(
			salledeclasse.intitule_classe
		) ||
			['ce2', 'cm1', 'cm2'].includes(salledeclasse.intitule_classe))
	) {
		renderedFields = (
			<>
				<Col xs={12} className="mb-3 mt-5">
					<Form.Group>
						{matiereOptions.map((matiere, index) => (
							<Row key={index} className="mb-3">
								<Col md={6} sm={12}>
									<Form.Label>{matiere.label}</Form.Label>
								</Col>
								<Col md={6} sm={12}>
									<Form.Control
										name={`note_matiere_${index}`}
										type="number"
										step="0.05"
										min="0"
										max={matiere.points}
										placeholder={`/ ${matiere.points}`}
										required
										isInvalid={!!feedbackMessages[`note_matiere_${index}`]}
										defaultValue={
											selectedBulletinNotes[index]
												? selectedBulletinNotes[index].note_matiere
												: ''
										}
										onChange={(e) => {
											setFeedbackMessages((prevMessages) => ({
												...prevMessages,
												[`note_matiere_${index}`]: e.target.value
													? ''
													: 'La note de la matière est requise.'
											}));
										}}
									/>
									<Form.Control.Feedback type="invalid">
										{feedbackMessages[`note_matiere_${index}`]}
									</Form.Control.Feedback>
									<input
										type="hidden"
										name={`matiere_${index}`}
										value={matiere.value}
									/>
									<input
										type="hidden"
										name={`id_${index}`}
										defaultValue={
											selectedBulletinNotes[index]
												? selectedBulletinNotes[index].id
												: ''
										}
									/>
								</Col>
							</Row>
						))}
					</Form.Group>
				</Col>
			</>
		);
	} else if (salledeclasse) {
		renderedFields = (
			<>
				<Col xs={12} className="mb-3">
					<Form.Group>
						{competenceOptions.map((competence, index) => (
							<Row key={index} className="mb-3 mt-5">
								<Col md={4} sm={12}>
									<Form.Label className="mt-6">{competence.label}</Form.Label>
								</Col>

								{competence.points_oral && (
									<Col md={2} sm={12} className="mb-3">
										<Form.Label>Oral</Form.Label>
										<Form.Control
											name={`note_oral_${index}`}
											type="number"
											step="0.05"
											min="0"
											max={competence.points_oral}
											placeholder={`/ ${competence.points_oral}`}
											required
											isInvalid={!!feedbackMessages[`note_oral_${index}`]}
											defaultValue={
												selectedBulletinNotes[index]
													? selectedBulletinNotes[index].note_oral
													: ''
											}
											onChange={(e) => {
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													[`note_oral_${index}`]: e.target.value
														? ''
														: 'La note de oral est requise.'
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages[`note_oral_${index}`]}
										</Form.Control.Feedback>
									</Col>
								)}

								{competence.points_ecrit && (
									<Col md={2} sm={12} className="mb-3">
										<Form.Label>Ecrit</Form.Label>
										<Form.Control
											name={`note_ecrit_${index}`}
											type="number"
											step="0.05"
											min="0"
											max={competence.points_ecrit}
											placeholder={`/ ${competence.points_ecrit}`}
											required
											isInvalid={!!feedbackMessages[`note_ecrit_${index}`]}
											defaultValue={
												selectedBulletinNotes[index]
													? selectedBulletinNotes[index].note_ecrit
													: ''
											}
											onChange={(e) => {
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													[`note_ecrit_${index}`]: e.target.value
														? ''
														: 'La note de ecrit est requise.'
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages[`note_ecrit_${index}`]}
										</Form.Control.Feedback>
									</Col>
								)}

								{competence.points_pratique && (
									<Col md={2} sm={12} className="mb-3">
										<Form.Label>Pratique</Form.Label>
										<Form.Control
											name={`note_pratique_${index}`}
											type="number"
											step="0.05"
											min="0"
											max={competence.points_pratique}
											placeholder={`/ ${competence.points_pratique}`}
											required
											isInvalid={!!feedbackMessages[`note_pratique_${index}`]}
											defaultValue={
												selectedBulletinNotes[index]
													? selectedBulletinNotes[index].note_pratique
													: ''
											}
											onChange={(e) => {
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													[`note_pratique_${index}`]: e.target.value
														? ''
														: 'La note de pratique est requise.'
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages[`note_pratique_${index}`]}
										</Form.Control.Feedback>
									</Col>
								)}

								{competence.points_savoir_etre && (
									<Col md={2} sm={12} className="mb-3">
										<Form.Label>Savoir-être</Form.Label>
										<Form.Control
											name={`note_savoir_etre_${index}`}
											type="number"
											step="0.05"
											min="0"
											max={competence.points_savoir_etre}
											placeholder={`/ ${competence.points_savoir_etre}`}
											required
											isInvalid={
												!!feedbackMessages[`note_savoir_etre_${index}`]
											}
											defaultValue={
												selectedBulletinNotes[index]
													? selectedBulletinNotes[index].note_savoir_etre
													: ''
											}
											onChange={(e) => {
												setFeedbackMessages((prevMessages) => ({
													...prevMessages,
													[`note_savoir_etre_${index}`]: e.target.value
														? ''
														: 'La note du savoir-être est requise.'
												}));
											}}
										/>
										<Form.Control.Feedback type="invalid">
											{feedbackMessages[`note_savoir_etre_${index}`]}
										</Form.Control.Feedback>
									</Col>
								)}

								<input
									type="hidden"
									name={`id_${index}`}
									defaultValue={
										selectedBulletinNotes[index]
											? selectedBulletinNotes[index].id
											: ''
									}
								/>
							</Row>
						))}
					</Form.Group>
				</Col>
			</>
		);
	}

	const convertToFloat = (value) => {
		if (!value) return null;
		return parseFloat(value.replace(',', '.'));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const { examen, eleve } = form;
				const notesData = [];

				if (
					salledeclasse &&
					(['class_four', 'class_five', 'class_six'].includes(
						salledeclasse.intitule_classe
					) ||
						['ce2', 'cm1', 'cm2'].includes(salledeclasse.intitule_classe))
				) {
					matiereOptions.forEach((matiere, index) => {
						const note_matiere = convertToFloat(
							form[`note_matiere_${index}`].value
						);
						const id = Number(form[`id_${index}`].value);

						const noteData = {
							id,
							matiere: matiere.value,
							note_matiere,
							competence: null,
							note_ecrit: null,
							note_oral: null,
							note_pratique: null,
							note_savoir_etre: null,
							moyenne_generale: null
						};
						notesData.push(noteData);
					});
				} else if (salledeclasse) {
					competenceOptions.forEach((competence, index) => {
						const id = Number(form[`id_${index}`].value);
						const note_ecrit = competence.points_ecrit
							? convertToFloat(form[`note_ecrit_${index}`].value)
							: null;
						const note_oral = competence.points_oral
							? convertToFloat(form[`note_oral_${index}`].value)
							: null;
						const note_pratique = competence.points_pratique
							? convertToFloat(form[`note_pratique_${index}`].value)
							: null;
						const note_savoir_etre = competence.points_savoir_etre
							? convertToFloat(form[`note_savoir_etre_${index}`].value)
							: null;

						const noteData = {
							id,
							competence: competence.value,
							note_ecrit,
							note_oral,
							note_pratique,
							note_savoir_etre,
							matiere: null,
							note_matiere: null
						};
						notesData.push(noteData);
					});
				}

				const bulletinData = {
					salledeclasse: parseInt(salledeclasseId, 10),
					eleve: parseInt(eleveId, 10),
					examen: parseInt(examen.value, 10),
					trimestre: parseInt(getTrimestre(examen.value), 10),
					annee_scolaire: parseInt(currentSchoolYear.id, 10)
				};

				const combinedData = {
					bulletin: bulletinData,
					notes: notesData
				};

				// Vérifier si notesData contient des valeurs nulles
				const hasInvalidNotes = notesData.some(
					(note) =>
						(note.matiere === null && note.competence === null) || // Aucun des deux n'est défini
						(note.matiere !== null && note.note_matiere === null) || // Matière définie mais pas la note
						(note.competence !== null &&
							note.note_ecrit === null &&
							note.note_oral === null &&
							note.note_pratique === null &&
							note.note_savoir_etre === null) // Compétence définie mais toutes les notes sont nulles
				);

				// Vérifier si bulletinData contient des valeurs nulles
				const hasInvalidBulletin = Object.values(bulletinData).some(
					(value) => value === null || isNaN(value)
				);

				if (hasInvalidNotes || hasInvalidBulletin) {
					alert(
						'Erreur : Certaines valeurs sont nulles. Veuillez vérifier votre saisie.'
					);
					return; // Arrête l'exécution de handleSubmit
				}

				// Declare the variable outside the conditional blocks
				let response;

				// Call the BulletinnoteService to create the Bulletin with its associated Notes
				if (Object.keys(selectedBulletinNotes).length > 0) {
					// If there are selected notes, perform an update
					response = await BulletinnoteService.updateBulletinWithNotes(
						bulletinId,
						combinedData
					);
				} else {
					// Otherwise, create a new bulletin with notes
					response = await BulletinnoteService.createBulletinnoteWithNotes(
						combinedData
					);
				}

				// Handle the response as needed
				if (response.status === 'success') {
					form.reset();
					setValidated(false);
					setFeedbackMessages({});
					window.location.href = `/pedagogie/notes/${salledeclasseId}/eleves/${eleveId}/print`;
				}
			} catch (error) {
				console.error('Erreur lors de la création du bulletin de notes', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}
		setValidated(true);
	};

	return (
		<BulletinnoteProfileLayout>
			<Card className="mb-3 ">
				{/* Card body */}
				<Card.Body>
					{/*  Form  */}
					<Form
						className="mb-3"
						noValidate
						validated={validated}
						onSubmit={handleSubmit}
					>
						{showAlert && (
							<Alert variant="danger">
								<ExclamationTriangleFill size={25} className="me-1" />
								{alertMessage}
							</Alert>
						)}
						<Row>
							{/* Examen */}
							<Col xs={12} className="mb-3">
								<Form.Group className="mb-3">
									<Form.Label htmlFor="examen">
										Examen <span className="text-danger">*</span>
									</Form.Label>
									<Form.Select
										name="examen"
										required
										isInvalid={!!feedbackMessages['examen']}
										onChange={(e) => {
											// D'abord, effacez les messages d'erreur liés à l'examen
											setFeedbackMessages((prevMessages) => ({
												...prevMessages,
												Examen: e.target.value ? '' : "L'examen est requis."
											}));

											// Appeler la méthode handleExamenChange lorsque l'examen est sélectionné
											handleExamenChange(e.target.value);
										}}
									>
										<option value="">Selectionner l'examen</option>
										{Examen_CHOICES.map((option, index) => (
											<option key={index} value={option.value}>
												{option.label}
											</option>
										))}
									</Form.Select>
									<Form.Control.Feedback type="invalid">
										{feedbackMessages['examen']}
									</Form.Control.Feedback>
								</Form.Group>
							</Col>
						</Row>

						<Row>{renderedFields}</Row>

						{/* Buttons */}

						<Col xs={12} className="mt-4">
							<Button variant="success" type="submit">
								Enregistrer
							</Button>
							<Button type="reset" variant="outline-danger" className="ms-2">
								Effacer
							</Button>
						</Col>
					</Form>
				</Card.Body>
			</Card>
		</BulletinnoteProfileLayout>
	);
};

export default ViewBulletinnote;
